import { useCallback } from 'react'
import { post } from 'aws-amplify/api'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useBugfixProject() {
  const { state, dispatch } = useAppContext()
  
  const addBugfixProject = useCallback(async (bugfix) => {
    dispatch({ type: actionTypes.ADD_BUGFIX_PROJECT_START })
    
    try {
      const { response } = post({
        apiName: 'CreateBugfixList',
        path: 'bugfixes',
        options: { body: bugfix }
      })
      const res = await response
      const data = await res.body.json()
      dispatch({
        type: actionTypes.ADD_BUGFIX_PROJECT_SUCCESS,
        payload: data
      })
      return data
    } catch (error) {
      console.error(error)
      dispatch({ type: actionTypes.ADD_BUGFIX_PROJECT_ERROR })
      throw error
    }
  }, [dispatch])
  
  const resetBugfixProject = useCallback(() => {
    dispatch({ type: actionTypes.RESET_ADD_BUGFIX_PROJECT })
  }, [dispatch])
  
  return {
    bugfixProject: state.bugfixProject,
    addBugfixProjectInProgress: state.addBugfixProjectInProgress,
    addBugfixProjectHasErrored: state.addBugfixProjectHasErrored,
    addBugfixProject,
    resetBugfixProject
  }
}
